<template>
    <div class="container-fluid">
        <div class="col-md-6 col-lg-4">
            <div class="panel-heading">
                <h3 class="panel-title">Cadastro de usuário</h3>
            </div>
            <form v-on:submit.prevent="submit">
                <div class="panel-body">
                    <div class="form-group">
                        <label class="form-group" for="name">Nome</label>
                        <input class="form-control" type="text" v-model="user.name" placeholder="Nome" name="name" id="name">
                        <span class="text-danger">{{ errors.hasOwnProperty('name') ? errors.name[0] : '' }}</span>
                    </div>
                    <div class="form-group">
                        <label class="form-group" for="login">Login</label>
                        <input class="form-control" type="text" v-model="user.login" placeholder="Login" name="login" id="login">
                        <span class="text-danger">{{ errors.hasOwnProperty('login') ? errors.login[0] : '' }}</span>
                    </div>
                    <div class="form-group">
                        <label class="form-group" for="email">Email</label>
                        <input class="form-control" type="email" v-model="user.email" placeholder="E-mail" name="email" id="email">
                        <span class="text-danger">{{ errors.hasOwnProperty('email') ? errors.email[0] : '' }}</span>
                    </div>
                    <div class="form-group">
                        <label class="form-group" for="password">Senha</label>
                        <input class="form-control" type="password" v-model="user.password" placeholder="Senha" name="password" id="password">
                        <span class="text-danger">{{ errors.hasOwnProperty('password') ? errors.password[0] : '' }}</span>
                    </div>
                    <div class="form-group">
                        <label class="form-group" for="workload">Carga horária</label>
                        <input class="form-control" v-mask="'##:##'" type="text" v-model="user.workload" placeholder="00:00" name="workload" id="workload">
                        <span class="text-danger">{{ errors.hasOwnProperty('workload') ? errors.workload[0] : '' }}</span>
                    </div>
                    <div class="form-group">
                        <label class="form-group" for="occupation_id">Função</label>
                        <v-select id="occupation_id" :reduce="occupation => occupation.id" label="name" v-model="user.occupation_id" :options="occupations" v-if="occupations"/>
                        <span class="text-danger">{{ errors.hasOwnProperty('occupation_id') ? errors.occupation_id[0] : '' }}</span>
                    </div>
                    <div class="form-group">
                        <label class="form-group" for="sector_id">Setor</label>
                        <v-select id="sector_id" :reduce="sector => sector.id" label="name" v-model="user.sector_id" :options="sectors" v-if="sectors"/>
                        <span class="text-danger">{{ errors.hasOwnProperty('sector_id') ? errors.sector_id[0] : '' }}</span>
                    </div>
                    <div class="form-group">
                        <label class="form-group" for="hired_at">Data admissão</label>
                        <date-picker
                            v-model ="hired_at"
                            format="DD/MM/YYYY"
                            v-mask="'##/##/####'"
                            id="hired_at"
                        >
                        </date-picker>
                        <span class="text-danger">{{ errors.hasOwnProperty('hired_at') ? errors.hired_at[0] : '' }}</span>
                    </div>
                    <div class="form-group">
                        <label class="form-group" for="fired_at">Data rescisão</label>
                        <date-picker
                            v-model ="fired_at"
                            format="DD/MM/YYYY"
                            v-mask="'##/##/####'"
                            id="fired_at"
                        >
                        </date-picker>
                        <span class="text-danger">{{ errors.hasOwnProperty('fired_at') ? errors.fired_at[0] : '' }}</span>
                    </div>
                    <div class="form-group">
                        <label class="form-group" for="role">Nivel do usuário</label>
                        <select class="form-select" required id="role" v-model="user.role" aria-label="Nivel do usuário">
                            <option value="supervisor">Supervisor</option>
                            <option value="leader">Líder</option>
                            <option value="employee">Funcionário</option>
                        </select>

                        <span class="text-danger">{{ errors.hasOwnProperty('fired_at') ? errors.fired_at[0] : '' }}</span>
                    </div>
                    <div class="form-group">
                        <input type="checkbox" id="launch_out_of_period" name="launch_out_of_period" v-model="user.launch_out_of_period">
                        <label class="control-label ms-2" for="launch_out_of_period">Pode fazer lançamentos fora do periodo</label>
                    </div>
                    <div class="form-group">
                      <input type="checkbox" id="not_require_yesterday_releases" name="not_require_yesterday_releases" v-model="user.not_require_yesterday_releases">
                      <label class="control-label ms-2" for="launch_out_of_period">Pode fazer lançamentos sem fechar dia anterior</label>
                    </div>
                    <div class="form-group">
                        <button type="submit" class="btn btn-primary">{{ user.hasOwnProperty('id') ? 'Editar' : 'Cadastrar' }}</button>
                    </div>
                </div>
            </form>
        </div>
    </div>


</template>

<script>
    import axios from 'axios'
    import DatePicker from 'vue2-datepicker';

    export default {
        name: 'user-form',
        props: ['user'],
        components: {
            DatePicker
        },
        data () {
            return {
                errors: {},
                hired_at: '',
                fired_at: '',
                occupations: false,
                sectors: false
            }
        },
        mounted () {
            axios
                .get('/api/occupations')
                .then((response) => {
                    this.occupations = response.data
                })
            axios
                .get('/api/sectors')
                .then((response) => {
                    this.sectors = response.data
                })

            if (Object.prototype.hasOwnProperty.call(this.user, 'id')) {
                this.hired_at  = new Date(this.user.hired_at + ' 12:00:00')
                if (this.user.fired_at) {
                    this.fired_at  = new Date(this.user.fired_at + ' 12:00:00')
                }
            }
        },
        methods: {
            create () {
                this.formatData()
                axios
                    .post('/api/users', this.user)
                    .then(() => {
                        this.$router.push({
                            name: 'users'
                        });
                    })
                    .catch((error) => {
                        this.errors = error.response.data.errors;
                    })
            },
            edit () {
                this.formatData()
                axios
                    .put('/api/users/' + this.user.id, this.user)
                    .then(() => {
                        this.$router.push({
                            name: 'users'
                        });
                    })
                    .catch((error) => {
                        this.errors = error.response.data.errors;
                    })
            },
            submit () {
                if (!Object.prototype.hasOwnProperty.call(this.user, 'id')) {
                    this.create()
                } else {
                    this.edit()
                }
            },
            formatData () {
                if (this.hired_at) {
                    this.user.hired_at = (this.hired_at.getFullYear() + "-" + ("0" + (this.hired_at.getMonth() + 1)).slice(-2) + "-" + ("0" + this.hired_at.getDate()).slice(-2));
                }
                if (this.fired_at) {
                    this.user.fired_at = (this.fired_at.getFullYear() + "-" + ("0" + (this.fired_at.getMonth() + 1)).slice(-2) + "-" + ("0" + this.fired_at.getDate()).slice(-2));
                }
            }
        }
    }
</script>


<style scoped lang="sass">
    .btn-primary
        margin-top: 30px
    .mx-datepicker
        display: block
        width: 100%
</style>
